import React from 'react';
import { Oval } from 'react-loader-spinner';

/**
 * @typedef {{
 *   className?: string,
 * } & import('react-loader-spinner').OvalProps} LoaderProps
 */

/** @type {React.FC<LoaderProps>} */
const Loader = ({ height = 50, width = 40, className, color = '#1c69d4', secondaryColor = '#333333', ...rest }) => (
  <Oval
    width={width}
    color={color}
    height={height}
    wrapperClass={className}
    secondaryColor={secondaryColor}
    {...rest}
  />
);

export default Loader;
